import { useCallback, useEffect, useRef, useState } from 'react';
import { pmApi } from './projectBaseApi';
export default function useProjectBase() {
  const [snapshot, setSnapshot] = useState(null),
    [error, setError] = useState(''),
    [busy, setBusy] = useState(false),
    [updated, setUpdated] = useState(null);
  const alive = useRef(true),
    writing = useRef(false),
    sequence = useRef(0);
  const refresh = useCallback(async () => {
    const request = ++sequence.current;
    try {
      const data = await pmApi.command('pm_dashboard');
      if (alive.current && request === sequence.current) {
        setSnapshot(prev => !prev || data.revision >= prev.revision ? data : prev);
        setUpdated(new Date());
        setError('');
      }
    } catch (e) {
      if (alive.current && request === sequence.current) setError(e.response?.data?.message || 'No se pudieron cargar los datos. Reintenta.');
    }
  }, []);
  useEffect(() => {
    alive.current = true;
    refresh();
    const timer = setInterval(() => {
      if (!writing.current) refresh();
    }, 20000);
    const focus = () => {
      if (!writing.current) refresh();
    };
    window.addEventListener('focus', focus);
    return () => {
      alive.current = false;
      clearInterval(timer);
      window.removeEventListener('focus', focus);
    };
  }, [refresh]);
  const execute = async (tool, args) => {
    writing.current = true;
    setBusy(true);
    try {
      const result = await pmApi.command(tool, args);
      await refresh();
      return result;
    } finally {
      writing.current = false;
      if (alive.current) setBusy(false);
    }
  };
  return {
    snapshot,
    error,
    busy,
    updated,
    refresh,
    execute
  };
}

